var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.97922 16.0541L5.40308 12.6445C5.30957 12.5543 5.1982 12.4826 5.07542 12.4337C4.95265 12.3848 4.82091 12.3596 4.68786 12.3596C4.5548 12.3596 4.42306 12.3848 4.30029 12.4337C4.17751 12.4826 4.06614 12.5543 3.97263 12.6445C3.87797 12.7337 3.80282 12.8398 3.75153 12.9569C3.70024 13.074 3.67383 13.1996 3.67383 13.3264C3.67383 13.4533 3.70024 13.5789 3.75153 13.6959C3.80282 13.813 3.87797 13.9192 3.97263 14.0083L8.25377 18.0901C8.65226 18.47 9.29596 18.47 9.69444 18.0901L20.525 7.77371C20.6197 7.68455 20.6948 7.57836 20.7461 7.46131C20.7974 7.34425 20.8238 7.21865 20.8238 7.09179C20.8238 6.96493 20.7974 6.83934 20.7461 6.72228C20.6948 6.60522 20.6197 6.49904 20.525 6.40988C20.4315 6.31964 20.3201 6.24799 20.1974 6.19908C20.0746 6.15018 19.9429 6.125 19.8098 6.125C19.6767 6.125 19.545 6.15018 19.4222 6.19908C19.2995 6.24799 19.1881 6.31964 19.0946 6.40988L8.97922 16.0541Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckmark);
export default __webpack_public_path__ + "static/media/ic_checkmark.caaf8c63a22d86793d55e41f8d9408d7.svg";
export { ForwardRef as ReactComponent };